
import {HeadBar, BccPasswordDialog} from '@/components';
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import PaymentInstance from './components/PaymentInstance';
import {PaymentProxy} from "@/http/RequestProxy.class";
import utils from "@/utils/utils";
import JSEncrypt from 'jsencrypt';
import hex_md5 from 'md5-hex';

const paymentProxy = new PaymentProxy();

export default {
name: 'payment',
components: {
PaymentInstance,
HeadBar,
Flexbox,
FlexboxItem,
BccPasswordDialog,
},
data(){
return {
dueAmount: 0,
startDate: '',
endDate: '',

orderInfo: {},
paymentInfo: {},
cardInfo: {},


query: {
payment_mode: 'WAP',
order_id: '',
payment_method: 1,
use_balance: 0, // 是否使用余额
use_bcc: 0,     // 是否使用bcc
bcc_pwd: '',    // bcc支付密码
},

isShowBccPwdDialog: false,    // 显示bcc密码输入框
bccPwdError: false,   // bcc密码是否有误
bccWallet: {},    // bcc相关数据
cardOptions: {},  // 通联支付卡号数据
};
},
mounted(){
if(!utils.isWechatBrowser()){
this.query.payment_method = 2;
}
this.query.order_id = this.$route.query.order_id;
this.getPaymentInfo();
this.setCode();
},
methods: {
/** 获取支付相关的信息 */
getPaymentInfo(){
this.$vux.loading.show();

paymentProxy.getPaymentInfo({orderId: this.query.order_id})
.then(resp => {
if(resp){
this.orderInfo = resp.data.order_info;
this.paymentInfo = resp.data.payment_info;
this.cardInfo = resp.data.foreign_card_rate;
this.dueAmount = resp.data.payment_info.due_amount;
this.startDate = utils.formatDateWithStamp(Number(resp.data.order_info.booking_start_time) * 1000, true);
this.endDate = utils.formatDateWithStamp(Number(resp.data.order_info.booking_end_time) * 1000, true);
}
this.$vux.loading.hide();
});
},

/** 获取bcc相关数据 */
onGetBccData(bccData){
this.bccWallet = bccData;
},

/** 选择第三方支付方式 */
onGetPayment(paymentType){
this.query.payment_method = paymentType;
},

/** 使用账户余额&BCC */
onGetBalanceAndBcc(resp){
resp.useBalance > 0 ? this.query.use_balance = 1 : this.query.use_balance = 0;
resp.useBcc > 0 ? this.query.use_bcc = 1 : this.query.use_bcc = 0;

this.dueAmount = Math.ceil(this.paymentInfo.due_amount - resp.useBalance - resp.useBcc);
},

/** 获取微信支付的code */
setCode(){
let href = window.location.href;

if(href.indexOf('code') > -1){
let query = href.split('?')[1].split('&')[1];
let codeArr = query.split('=');


if(codeArr[0] == 'code'){
this.query = Object.assign({}, this.query, {code: codeArr[1]});
setTimeout(() => {
this.onSubmitPayment();
}, 2000);
}
}
},

/** 发起支付 */
onSubmitPayment(){

if(this.query.payment_method === 10 && !this.query.extra_param){
this.encryptAllinParams();
return false;
}


if(+this.query.use_bcc === 1 && !this.bccWallet.is_set_pwd){
this.$vux.confirm.show({
content: '您还没有设置bcc支付密码！',
confirmText: '前往设置',
cancelText: '取消',
onConfirm(){
window.location.href = `${this.$store.state.WAP_HOST}`;
}
});
return false;
}


if(+this.query.use_bcc === 1 && !this.query.bcc_pwd){

this.isShowBccPwdDialog = true;
return false;
}

this.$vux.loading.show();
paymentProxy.submitPayment(this.query)
.then(resp => {
if(resp){
if(resp.data.is_pay_finish){









this.$router.push({name: 'payment-success', params: {order_id: this.query.order_id}});
}else{

if(+resp.code === 30902){
this.bccPwdError = true;

}else{
let consume = resp.data.third_party_consume_param.consume;

if(resp.data.third_party_consume_param.service == '微信支付'){
if(consume.need_user_auth){
window.location.href = consume.auth_url;
}else{
utils.wxPayment(consume.param)
.then(resp => {
if(resp){
this.$router.push({name: 'payment-success', params: {order_id: this.query.order_id}});
}else{
this.$vux.toast.show('支付失败');
}
});
}
}else{
utils.otherPayment(resp.data.third_party_consume_param.consume.form);
}
}

delete this.query.extra_param;  
}
}
this.$vux.loading.hide();
});
},

/** 获取通联支付卡号相关信息 */
onGetAllinCard(data){
this.cardOptions = data;
},

/** 通联支付非空检测 */
checkCreditCardInput(){
const cardNum = this.cardOptions.cardNumber,
cardName = this.cardOptions.cardHolderName,
cardDate = this.cardOptions.cardExpireDate,
securityNum = this.cardOptions.securityNumber;

if(!cardNum || cardNum.length < 15){
this.$vux.toast.show(this.$i18n.t('hotel.ENTER_COMPLETE_CARD_NUM'));
return false;
}

if(!cardName){
this.$vux.toast.show(this.$i18n.t('hotel.PLEASE_ENTER_HOLDER_NAME'));
return false;
}

if(!cardDate){
this.$vux.toast.show(this.$i18n.t('hotel.ENTER_EXPIRATION_DATE'));
return false;
}

if(!securityNum){
this.$vux.toast.show(this.$i18n.t('hotel.ENTER_SECURITY_CODE'));
return false;
}








return true;
},

/** 加密通联支付相关字段 */
encryptAllinParams(){
if(!this.checkCreditCardInput()){
return false;
}

let cdNum = this.cardOptions.cardNumber.replace(/\s/g, ''),
month = this.cardOptions.cardExpireDate.split('/')[0],
year = this.cardOptions.cardExpireDate.split('/')[1],
encStrTemp = this.cardOptions.cardHolderName + '\n' + cdNum + '\n' + month + '\n' + year + '\n' + this.cardOptions.securityNumber,
md5StrTemp = this.cardOptions.cardHolderName + cdNum + month + year + this.cardOptions.securityNumber;

this.$vux.loading.show();
paymentProxy.getSecurityCode({order_id: this.query.order_id})
.then(resp => {
if(resp){
var securityData = resp.data;
var publicKey = securityData.public_key;	
var secretHash = {};
var encrypt = new JSEncrypt();

encStrTemp += '\nPASSWORD_AUTH\n' + securityData.timestamp + '\n' + securityData.secure_code + '\n' + this.query.bcc_pwd;
md5StrTemp += 'PASSWORD_AUTH' + securityData.timestamp + securityData.secure_code + this.query.bcc_pwd;

encrypt.setPublicKey(publicKey);	
secretHash.password_enc = encrypt.encrypt(encStrTemp);
secretHash.verify = hex_md5(md5StrTemp);
secretHash.secure_code = securityData.secure_code;

this.query.extra_param = {
secret: secretHash,
};
this.onSubmitPayment();
}
this.$vux.loading.hide();
});
},
},
}



// WEBPACK FOOTER //
// ./src/views/payment/hotel-payment.vue